import React from 'react';
import { motion } from 'framer-motion';
const painPoints = [{
  emoji: '😤',
  text: 'Le pediste cotización a tres diseñadores. $1,500-$5,000 y tardan 6-12 semanas.'
}, {
  emoji: '😮‍💨',
  text: 'Intentaste WordPress. Terminaste llorando frente a un error de plugin a las 2 AM.'
}, {
  emoji: '🫠',
  text: 'Compraste una plantilla en Canva o Wix. Se ve igual a la de otras 40,000 personas.'
}, {
  emoji: '💸',
  text: 'Cada semana sin página = clientes que encuentran a tu competencia en vez de ti.'
}];
export function Problem() {
  return <section className="py-20 px-4 bg-white" data-id="element-106">
      <div className="max-w-5xl mx-auto" data-id="element-107">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-108">
          <h2 className="font-playfair text-4xl md:text-6xl font-bold text-gray-900 mb-6 text-center" data-id="element-109">
            Seamos Honestos por un Segundo…
          </h2>
          <p className="text-xl md:text-2xl text-gray-700 mb-16 text-center max-w-3xl mx-auto" data-id="element-110">
            Llevas meses diciendo "esta semana sí hago mi página web". Y aquí
            sigues. Sin página. Perdiendo clientes cada día.
          </p>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-111">
            {painPoints.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="border-l-4 border-violet-600 bg-violet-50 p-6 rounded-r-lg" data-id="element-112">
                <div className="flex items-start gap-4" data-id="element-113">
                  <span className="text-4xl flex-shrink-0" data-id="element-114">{point.emoji}</span>
                  <p className="text-lg text-gray-800 leading-relaxed" data-id="element-115">
                    {point.text}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}